module.exports = __webpack_public_path__ + "static/img/no1.62ce771.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/awardPH/img/no1.png
// module id = x8wL
// module chunks = 1